import { Visitor } from '@/types/residents/visitor';
import dayjs from 'dayjs';

export const visitors: Visitor[] = [
  {
    id: 'VIS001',
    type: 'guest',
    status: 'checked_in',
    name: 'Sarah Johnson',
    phone: '+1-555-0123',
    email: 'sarah.j@email.com',
    idType: 'passport',
    idNumber: 'P12345678',
    resident: {
      id: 'RES001',
      name: 'John Doe'
    },
    expectedArrival: dayjs('2024-03-15T14:00:00').toDate(),
    expectedDeparture: dayjs('2024-03-17T12:00:00').toDate(),
    actualArrival: dayjs('2024-03-15T14:30:00').toDate(),
    purpose: 'Family Visit',
    numberOfVisitors: 2,
    vehicleDetails: {
      type: 'Sedan',
      number: 'ABC123',
      color: 'Silver'
    },
    attachments: [
      {
        id: 'ATT001',
        name: 'Passport Copy',
        type: 'pdf',
        size: 1024,
        path: '/documents/visitors/VIS001/passport.pdf',
        url: '/documents/visitors/VIS001/passport.pdf',
        uploadedAt: dayjs('2024-03-15').toDate()
      }
    ]
  },
  {
    id: 'VIS002',
    type: 'service',
    status: 'approved',
    name: 'Mike Chen',
    phone: '+1-555-0124',
    email: 'mike.chen@plumbing.com',
    idType: 'drivers_license',
    idNumber: 'DL98765432',
    resident: {
      id: 'RES002',
      name: 'Jane Smith'
    },
    expectedArrival: dayjs('2024-03-16T09:00:00').toDate(),
    expectedDeparture: dayjs('2024-03-16T11:00:00').toDate(),
    purpose: 'Plumbing Repair',
    numberOfVisitors: 1,
    vehicleDetails: {
      type: 'Van',
      number: 'XYZ789',
      color: 'White'
    }
  },
  {
    id: 'VIS003',
    type: 'delivery',
    status: 'checked_in',
    name: 'Alex Rodriguez',
    phone: '+1-555-0125',
    email: 'alex.r@delivery.com',
    idType: 'national_id',
    idNumber: 'EMP456789',
    resident: {
      id: 'RES003',
      name: 'Mike Johnson'
    },
    expectedArrival: dayjs('2024-03-17T10:00:00').toDate(),
    expectedDeparture: dayjs('2024-03-17T10:30:00').toDate(),
    actualArrival: dayjs('2024-03-17T10:15:00').toDate(),
    purpose: 'Package Delivery',
    numberOfVisitors: 1,
    vehicleDetails: {
      type: 'Truck',
      number: 'DEL123',
      color: 'Brown'
    }
  },
  {
    id: 'VIS004',
    type: 'contractor',
    status: 'pending',
    name: 'David Wilson',
    phone: '+1-555-0126',
    email: 'david.w@construction.com',
    idType: 'other',
    idNumber: 'BL789123',
    resident: {
      id: 'RES004',
      name: 'Emily Davis'
    },
    expectedArrival: dayjs('2024-03-18T08:00:00').toDate(),
    expectedDeparture: dayjs('2024-03-18T17:00:00').toDate(),
    purpose: 'Kitchen Renovation',
    numberOfVisitors: 3,
    vehicleDetails: {
      type: 'Pickup',
      number: 'CON456',
      color: 'Red'
    }
  },
  {
    id: 'VIS005',
    type: 'guest',
    status: 'checked_out',
    name: 'Lisa Brown',
    phone: '+1-555-0127',
    email: 'lisa.b@email.com',
    idType: 'passport',
    idNumber: 'P87654321',
    resident: {
      id: 'RES005',
      name: 'David Wilson'
    },
    expectedArrival: dayjs('2024-03-19T15:00:00').toDate(),
    expectedDeparture: dayjs('2024-03-21T10:00:00').toDate(),
    actualArrival: dayjs('2024-03-19T15:30:00').toDate(),
    actualDeparture: dayjs('2024-03-21T09:45:00').toDate(),
    purpose: 'Weekend Visit',
    numberOfVisitors: 1
  },
  {
    id: 'VIS006',
    type: 'service',
    status: 'approved',
    name: 'Robert Taylor',
    phone: '+1-555-0128',
    email: 'robert.t@cleaning.com',
    idType: 'drivers_license',
    idNumber: 'DL12345678',
    resident: {
      id: 'RES006',
      name: 'Lisa Brown'
    },
    expectedArrival: dayjs('2024-03-20T13:00:00').toDate(),
    expectedDeparture: dayjs('2024-03-20T15:00:00').toDate(),
    purpose: 'House Cleaning',
    numberOfVisitors: 2,
    vehicleDetails: {
      type: 'Van',
      number: 'CLN789',
      color: 'Blue'
    }
  },
  {
    id: 'VIS007',
    type: 'delivery',
    status: 'checked_in',
    name: 'Jennifer Garcia',
    phone: '+1-555-0129',
    email: 'jennifer.g@food.com',
    idType: 'national_id',
    idNumber: 'EMP789456',
    resident: {
      id: 'RES007',
      name: 'Sarah Miller'
    },
    expectedArrival: dayjs('2024-03-21T12:00:00').toDate(),
    expectedDeparture: dayjs('2024-03-21T12:15:00').toDate(),
    actualArrival: dayjs('2024-03-21T12:05:00').toDate(),
    purpose: 'Food Delivery',
    numberOfVisitors: 1,
    vehicleDetails: {
      type: 'Motorcycle',
      number: 'FOOD123',
      color: 'Orange'
    }
  },
  {
    id: 'VIS008',
    type: 'contractor',
    status: 'rejected',
    name: 'Michael Anderson',
    phone: '+1-555-0130',
    email: 'michael.a@electrical.com',
    idType: 'other',
    idNumber: 'BL456789',
    resident: {
      id: 'RES008',
      name: 'Robert Taylor'
    },
    expectedArrival: dayjs('2024-03-22T09:00:00').toDate(),
    expectedDeparture: dayjs('2024-03-22T16:00:00').toDate(),
    purpose: 'Electrical Work',
    numberOfVisitors: 2,
    vehicleDetails: {
      type: 'Van',
      number: 'ELEC456',
      color: 'Yellow'
    }
  },
  {
    id: 'VIS009',
    type: 'guest',
    status: 'expired',
    name: 'Amanda Martinez',
    phone: '+1-555-0131',
    email: 'amanda.m@email.com',
    idType: 'passport',
    idNumber: 'P65432198',
    resident: {
      id: 'RES009',
      name: 'Michael Anderson'
    },
    expectedArrival: dayjs('2024-03-23T14:00:00').toDate(),
    expectedDeparture: dayjs('2024-03-25T11:00:00').toDate(),
    purpose: 'Family Visit',
    numberOfVisitors: 2
  },
  {
    id: 'VIS010',
    type: 'service',
    status: 'approved',
    name: 'Christopher Lee',
    phone: '+1-555-0132',
    email: 'chris.l@landscaping.com',
    idType: 'drivers_license',
    idNumber: 'DL98765432',
    resident: {
      id: 'RES010',
      name: 'Jennifer Garcia'
    },
    expectedArrival: dayjs('2024-03-24T07:00:00').toDate(),
    expectedDeparture: dayjs('2024-03-24T12:00:00').toDate(),
    purpose: 'Garden Maintenance',
    numberOfVisitors: 3,
    vehicleDetails: {
      type: 'Truck',
      number: 'LAND789',
      color: 'Green'
    }
  },
  {
    id: 'VIS011',
    type: 'delivery',
    status: 'checked_in',
    name: 'Nicole Rodriguez',
    phone: '+1-555-0133',
    email: 'nicole.r@furniture.com',
    idType: 'national_id',
    idNumber: 'EMP321654',
    resident: {
      id: 'RES011',
      name: 'Amanda Martinez'
    },
    expectedArrival: dayjs('2024-03-25T10:00:00').toDate(),
    expectedDeparture: dayjs('2024-03-25T11:30:00').toDate(),
    actualArrival: dayjs('2024-03-25T10:20:00').toDate(),
    purpose: 'Furniture Delivery',
    numberOfVisitors: 2,
    vehicleDetails: {
      type: 'Truck',
      number: 'FURN456',
      color: 'White'
    }
  },
  {
    id: 'VIS012',
    type: 'contractor',
    status: 'pending',
    name: 'Kevin White',
    phone: '+1-555-0134',
    email: 'kevin.w@painting.com',
    idType: 'other',
    idNumber: 'BL654321',
    resident: {
      id: 'RES012',
      name: 'Christopher Lee'
    },
    expectedArrival: dayjs('2024-03-26T08:00:00').toDate(),
    expectedDeparture: dayjs('2024-03-28T17:00:00').toDate(),
    purpose: 'House Painting',
    numberOfVisitors: 4,
    vehicleDetails: {
      type: 'Van',
      number: 'PAINT123',
      color: 'Gray'
    }
  },
  {
    id: 'VIS013',
    type: 'guest',
    status: 'approved',
    name: 'Stephanie Clark',
    phone: '+1-555-0135',
    email: 'stephanie.c@email.com',
    idType: 'passport',
    idNumber: 'P32165498',
    resident: {
      id: 'RES013',
      name: 'Nicole Rodriguez'
    },
    expectedArrival: dayjs('2024-03-27T16:00:00').toDate(),
    expectedDeparture: dayjs('2024-03-29T14:00:00').toDate(),
    purpose: 'Weekend Stay',
    numberOfVisitors: 1
  },
  {
    id: 'VIS014',
    type: 'service',
    status: 'checked_in',
    name: 'Daniel Lewis',
    phone: '+1-555-0136',
    email: 'daniel.l@hvac.com',
    idType: 'drivers_license',
    idNumber: 'DL65432198',
    resident: {
      id: 'RES014',
      name: 'Kevin White'
    },
    expectedArrival: dayjs('2024-03-28T11:00:00').toDate(),
    expectedDeparture: dayjs('2024-03-28T13:00:00').toDate(),
    actualArrival: dayjs('2024-03-28T11:15:00').toDate(),
    purpose: 'AC Repair',
    numberOfVisitors: 1,
    vehicleDetails: {
      type: 'Van',
      number: 'HVAC789',
      color: 'Silver'
    }
  },
  {
    id: 'VIS015',
    type: 'delivery',
    status: 'approved',
    name: 'Rachel Hall',
    phone: '+1-555-0137',
    email: 'rachel.h@appliance.com',
    idType: 'national_id',
    idNumber: 'EMP654321',
    resident: {
      id: 'RES015',
      name: 'Stephanie Clark'
    },
    expectedArrival: dayjs('2024-03-29T09:00:00').toDate(),
    expectedDeparture: dayjs('2024-03-29T10:30:00').toDate(),
    purpose: 'Appliance Delivery',
    numberOfVisitors: 2,
    vehicleDetails: {
      type: 'Truck',
      number: 'APP456',
      color: 'Black'
    }
  },
  {
    id: 'VIS016',
    type: 'contractor',
    status: 'approved',
    name: 'Thomas Young',
    phone: '+1-555-0138',
    email: 'thomas.y@carpentry.com',
    idType: 'other',
    idNumber: 'BL321654',
    resident: {
      id: 'RES016',
      name: 'Daniel Lewis'
    },
    expectedArrival: dayjs('2024-03-30T08:00:00').toDate(),
    expectedDeparture: dayjs('2024-04-01T17:00:00').toDate(),
    purpose: 'Custom Furniture',
    numberOfVisitors: 2,
    vehicleDetails: {
      type: 'Pickup',
      number: 'CARP123',
      color: 'Brown'
    }
  },
  {
    id: 'VIS017',
    type: 'guest',
    status: 'pending',
    name: 'Michelle King',
    phone: '+1-555-0139',
    email: 'michelle.k@email.com',
    idType: 'passport',
    idNumber: 'P65432198',
    resident: {
      id: 'RES017',
      name: 'Rachel Hall'
    },
    expectedArrival: dayjs('2024-04-01T17:00:00').toDate(),
    expectedDeparture: dayjs('2024-04-03T15:00:00').toDate(),
    purpose: 'Business Trip',
    numberOfVisitors: 1
  },
  {
    id: 'VIS018',
    type: 'service',
    status: 'checked_in',
    name: 'James Scott',
    phone: '+1-555-0140',
    email: 'james.s@security.com',
    idType: 'drivers_license',
    idNumber: 'DL32165498',
    resident: {
      id: 'RES018',
      name: 'Thomas Young'
    },
    expectedArrival: dayjs('2024-04-02T14:00:00').toDate(),
    expectedDeparture: dayjs('2024-04-02T16:00:00').toDate(),
    actualArrival: dayjs('2024-04-02T14:10:00').toDate(),
    purpose: 'Security System Installation',
    numberOfVisitors: 1,
    vehicleDetails: {
      type: 'Van',
      number: 'SEC789',
      color: 'Dark Blue'
    }
  },
  {
    id: 'VIS019',
    type: 'delivery',
    status: 'approved',
    name: 'Ashley Green',
    phone: '+1-555-0141',
    email: 'ashley.g@electronics.com',
    idType: 'national_id',
    idNumber: 'EMP987654',
    resident: {
      id: 'RES019',
      name: 'Michelle King'
    },
    expectedArrival: dayjs('2024-04-03T13:00:00').toDate(),
    expectedDeparture: dayjs('2024-04-03T14:30:00').toDate(),
    purpose: 'TV Installation',
    numberOfVisitors: 1,
    vehicleDetails: {
      type: 'Van',
      number: 'ELEC123',
      color: 'White'
    }
  },
  {
    id: 'VIS020',
    type: 'contractor',
    status: 'pending',
    name: 'Brandon Baker',
    phone: '+1-555-0142',
    email: 'brandon.b@roofing.com',
    idType: 'other',
    idNumber: 'BL987654',
    resident: {
      id: 'RES020',
      name: 'James Scott'
    },
    expectedArrival: dayjs('2024-04-04T07:00:00').toDate(),
    expectedDeparture: dayjs('2024-04-06T17:00:00').toDate(),
    purpose: 'Roof Repair',
    numberOfVisitors: 3,
    vehicleDetails: {
      type: 'Truck',
      number: 'ROOF456',
      color: 'Gray'
    }
  },
  {
    id: 'VIS021',
    type: 'guest',
    status: 'checked_out',
    name: 'Lauren Adams',
    phone: '+1-555-0143',
    email: 'lauren.a@email.com',
    idType: 'passport',
    idNumber: 'P98765432',
    resident: {
      id: 'RES021',
      name: 'Ashley Green'
    },
    expectedArrival: dayjs('2024-04-05T18:00:00').toDate(),
    expectedDeparture: dayjs('2024-04-07T12:00:00').toDate(),
    actualArrival: dayjs('2024-04-05T18:30:00').toDate(),
    actualDeparture: dayjs('2024-04-07T11:45:00').toDate(),
    purpose: 'Weekend Visit',
    numberOfVisitors: 2
  },
  {
    id: 'VIS022',
    type: 'service',
    status: 'approved',
    name: 'Ryan Nelson',
    phone: '+1-555-0144',
    email: 'ryan.n@pool.com',
    idType: 'drivers_license',
    idNumber: 'DL65432198',
    resident: {
      id: 'RES022',
      name: 'Brandon Baker'
    },
    expectedArrival: dayjs('2024-04-06T10:00:00').toDate(),
    expectedDeparture: dayjs('2024-04-06T12:00:00').toDate(),
    purpose: 'Pool Maintenance',
    numberOfVisitors: 1,
    vehicleDetails: {
      type: 'Van',
      number: 'POOL789',
      color: 'Blue'
    }
  },
  {
    id: 'VIS023',
    type: 'delivery',
    status: 'checked_in',
    name: 'Samantha Carter',
    phone: '+1-555-0145',
    email: 'samantha.c@florist.com',
    idType: 'national_id',
    idNumber: 'EMP654321',
    resident: {
      id: 'RES023',
      name: 'Lauren Adams'
    },
    expectedArrival: dayjs('2024-04-07T11:00:00').toDate(),
    expectedDeparture: dayjs('2024-04-07T11:15:00').toDate(),
    actualArrival: dayjs('2024-04-07T11:05:00').toDate(),
    purpose: 'Flower Delivery',
    numberOfVisitors: 1,
    vehicleDetails: {
      type: 'Motorcycle',
      number: 'FLOW123',
      color: 'Pink'
    }
  },
  {
    id: 'VIS024',
    type: 'contractor',
    status: 'rejected',
    name: 'Justin Mitchell',
    phone: '+1-555-0146',
    email: 'justin.m@flooring.com',
    idType: 'other',
    idNumber: 'BL321654',
    resident: {
      id: 'RES024',
      name: 'Ryan Nelson'
    },
    expectedArrival: dayjs('2024-04-08T08:00:00').toDate(),
    expectedDeparture: dayjs('2024-04-10T17:00:00').toDate(),
    purpose: 'Floor Installation',
    numberOfVisitors: 2,
    vehicleDetails: {
      type: 'Van',
      number: 'FLOOR456',
      color: 'Beige'
    }
  },
  {
    id: 'VIS025',
    type: 'guest',
    status: 'expired',
    name: 'Melissa Perez',
    phone: '+1-555-0147',
    email: 'melissa.p@email.com',
    idType: 'passport',
    idNumber: 'P65432198',
    resident: {
      id: 'RES025',
      name: 'Samantha Carter'
    },
    expectedArrival: dayjs('2024-04-09T19:00:00').toDate(),
    expectedDeparture: dayjs('2024-04-11T16:00:00').toDate(),
    purpose: 'Family Visit',
    numberOfVisitors: 3
  },
  {
    id: 'VIS026',
    type: 'service',
    status: 'approved',
    name: 'Gregory Roberts',
    phone: '+1-555-0148',
    email: 'gregory.r@window.com',
    idType: 'drivers_license',
    idNumber: 'DL98765432',
    resident: {
      id: 'RES026',
      name: 'Justin Mitchell'
    },
    expectedArrival: dayjs('2024-04-10T09:00:00').toDate(),
    expectedDeparture: dayjs('2024-04-10T15:00:00').toDate(),
    purpose: 'Window Replacement',
    numberOfVisitors: 2,
    vehicleDetails: {
      type: 'Truck',
      number: 'WIN789',
      color: 'White'
    }
  },
  {
    id: 'VIS027',
    type: 'delivery',
    status: 'checked_in',
    name: 'Hannah Turner',
    phone: '+1-555-0149',
    email: 'hannah.t@clothing.com',
    idType: 'national_id',
    idNumber: 'EMP321654',
    resident: {
      id: 'RES027',
      name: 'Melissa Perez'
    },
    expectedArrival: dayjs('2024-04-11T14:00:00').toDate(),
    expectedDeparture: dayjs('2024-04-11T14:10:00').toDate(),
    actualArrival: dayjs('2024-04-11T14:05:00').toDate(),
    purpose: 'Clothing Delivery',
    numberOfVisitors: 1,
    vehicleDetails: {
      type: 'Motorcycle',
      number: 'CLOTH123',
      color: 'Red'
    }
  },
  {
    id: 'VIS028',
    type: 'contractor',
    status: 'pending',
    name: 'Nathan Phillips',
    phone: '+1-555-0150',
    email: 'nathan.p@decking.com',
    idType: 'other',
    idNumber: 'BL654321',
    resident: {
      id: 'RES028',
      name: 'Gregory Roberts'
    },
    expectedArrival: dayjs('2024-04-12T07:00:00').toDate(),
    expectedDeparture: dayjs('2024-04-14T17:00:00').toDate(),
    purpose: 'Deck Construction',
    numberOfVisitors: 4,
    vehicleDetails: {
      type: 'Truck',
      number: 'DECK456',
      color: 'Brown'
    }
  },
  {
    id: 'VIS029',
    type: 'guest',
    status: 'approved',
    name: 'Victoria Campbell',
    phone: '+1-555-0151',
    email: 'victoria.c@email.com',
    idType: 'passport',
    idNumber: 'P32165498',
    resident: {
      id: 'RES029',
      name: 'Hannah Turner'
    },
    expectedArrival: dayjs('2024-04-13T20:00:00').toDate(),
    expectedDeparture: dayjs('2024-04-15T18:00:00').toDate(),
    purpose: 'Weekend Stay',
    numberOfVisitors: 1
  },
  {
    id: 'VIS030',
    type: 'service',
    status: 'checked_in',
    name: 'Derek Parker',
    phone: '+1-555-0152',
    email: 'derek.p@garage.com',
    idType: 'drivers_license',
    idNumber: 'DL65432198',
    resident: {
      id: 'RES030',
      name: 'Nathan Phillips'
    },
    expectedArrival: dayjs('2024-04-14T12:00:00').toDate(),
    expectedDeparture: dayjs('2024-04-14T14:00:00').toDate(),
    actualArrival: dayjs('2024-04-14T12:15:00').toDate(),
    purpose: 'Garage Door Repair',
    numberOfVisitors: 1,
    vehicleDetails: {
      type: 'Van',
      number: 'GAR789',
      color: 'Silver'
    }
  },
  {
    id: 'VIS031',
    type: 'delivery',
    status: 'approved',
    name: 'Olivia Evans',
    phone: '+1-555-0153',
    email: 'olivia.e@books.com',
    idType: 'national_id',
    idNumber: 'EMP654321',
    resident: {
      id: 'RES031',
      name: 'Victoria Campbell'
    },
    expectedArrival: dayjs('2024-04-15T15:00:00').toDate(),
    expectedDeparture: dayjs('2024-04-15T15:05:00').toDate(),
    purpose: 'Book Delivery',
    numberOfVisitors: 1,
    vehicleDetails: {
      type: 'Motorcycle',
      number: 'BOOK123',
      color: 'Blue'
    }
  },
  {
    id: 'VIS032',
    type: 'contractor',
    status: 'approved',
    name: 'Tyler Edwards',
    phone: '+1-555-0154',
    email: 'tyler.e@fencing.com',
    idType: 'other',
    idNumber: 'BL321654',
    resident: {
      id: 'RES032',
      name: 'Derek Parker'
    },
    expectedArrival: dayjs('2024-04-16T08:00:00').toDate(),
    expectedDeparture: dayjs('2024-04-18T17:00:00').toDate(),
    purpose: 'Fence Installation',
    numberOfVisitors: 3,
    vehicleDetails: {
      type: 'Truck',
      number: 'FENCE456',
      color: 'Green'
    }
  },
  {
    id: 'VIS033',
    type: 'guest',
    status: 'pending',
    name: 'Zoe Collins',
    phone: '+1-555-0155',
    email: 'zoe.c@email.com',
    idType: 'passport',
    idNumber: 'P65432198',
    resident: {
      id: 'RES033',
      name: 'Olivia Evans'
    },
    expectedArrival: dayjs('2024-04-17T21:00:00').toDate(),
    expectedDeparture: dayjs('2024-04-19T19:00:00').toDate(),
    purpose: 'Business Meeting',
    numberOfVisitors: 1
  },
  {
    id: 'VIS034',
    type: 'service',
    status: 'checked_in',
    name: 'Ethan Stewart',
    phone: '+1-555-0156',
    email: 'ethan.s@pest.com',
    idType: 'drivers_license',
    idNumber: 'DL98765432',
    resident: {
      id: 'RES034',
      name: 'Tyler Edwards'
    },
    expectedArrival: dayjs('2024-04-18T13:00:00').toDate(),
    expectedDeparture: dayjs('2024-04-18T15:00:00').toDate(),
    actualArrival: dayjs('2024-04-18T13:10:00').toDate(),
    purpose: 'Pest Control',
    numberOfVisitors: 1,
    vehicleDetails: {
      type: 'Van',
      number: 'PEST789',
      color: 'White'
    }
  },
  {
    id: 'VIS035',
    type: 'delivery',
    status: 'approved',
    name: 'Ava Morris',
    phone: '+1-555-0157',
    email: 'ava.m@jewelry.com',
    idType: 'national_id',
    idNumber: 'EMP321654',
    resident: {
      id: 'RES035',
      name: 'Zoe Collins'
    },
    expectedArrival: dayjs('2024-04-19T16:00:00').toDate(),
    expectedDeparture: dayjs('2024-04-19T16:10:00').toDate(),
    purpose: 'Jewelry Delivery',
    numberOfVisitors: 1,
    vehicleDetails: {
      type: 'Motorcycle',
      number: 'JEWEL123',
      color: 'Gold'
    }
  },
  {
    id: 'VIS036',
    type: 'contractor',
    status: 'pending',
    name: 'Liam Rogers',
    phone: '+1-555-0158',
    email: 'liam.r@siding.com',
    idType: 'other',
    idNumber: 'BL654321',
    resident: {
      id: 'RES036',
      name: 'Ethan Stewart'
    },
    expectedArrival: dayjs('2024-04-20T07:00:00').toDate(),
    expectedDeparture: dayjs('2024-04-22T17:00:00').toDate(),
    purpose: 'Siding Replacement',
    numberOfVisitors: 3,
    vehicleDetails: {
      type: 'Truck',
      number: 'SIDE456',
      color: 'Gray'
    }
  },
  {
    id: 'VIS037',
    type: 'guest',
    status: 'checked_out',
    name: 'Mia Reed',
    phone: '+1-555-0159',
    email: 'mia.r@email.com',
    idType: 'passport',
    idNumber: 'P98765432',
    resident: {
      id: 'RES037',
      name: 'Ava Morris'
    },
    expectedArrival: dayjs('2024-04-21T22:00:00').toDate(),
    expectedDeparture: dayjs('2024-04-23T20:00:00').toDate(),
    actualArrival: dayjs('2024-04-21T22:30:00').toDate(),
    actualDeparture: dayjs('2024-04-23T19:45:00').toDate(),
    purpose: 'Weekend Visit',
    numberOfVisitors: 2
  },
  {
    id: 'VIS038',
    type: 'service',
    status: 'approved',
    name: 'Noah Cook',
    phone: '+1-555-0160',
    email: 'noah.c@chimney.com',
    idType: 'drivers_license',
    idNumber: 'DL65432198',
    resident: {
      id: 'RES038',
      name: 'Liam Rogers'
    },
    expectedArrival: dayjs('2024-04-22T11:00:00').toDate(),
    expectedDeparture: dayjs('2024-04-22T13:00:00').toDate(),
    purpose: 'Chimney Cleaning',
    numberOfVisitors: 1,
    vehicleDetails: {
      type: 'Van',
      number: 'CHIM789',
      color: 'Black'
    }
  },
  {
    id: 'VIS039',
    type: 'delivery',
    status: 'checked_in',
    name: 'Isabella Morgan',
    phone: '+1-555-0161',
    email: 'isabella.m@wine.com',
    idType: 'national_id',
    idNumber: 'EMP654321',
    resident: {
      id: 'RES039',
      name: 'Mia Reed'
    },
    expectedArrival: dayjs('2024-04-23T17:00:00').toDate(),
    expectedDeparture: dayjs('2024-04-23T17:15:00').toDate(),
    actualArrival: dayjs('2024-04-23T17:05:00').toDate(),
    purpose: 'Wine Delivery',
    numberOfVisitors: 1,
    vehicleDetails: {
      type: 'Motorcycle',
      number: 'WINE123',
      color: 'Purple'
    }
  },
  {
    id: 'VIS040',
    type: 'contractor',
    status: 'rejected',
    name: 'Mason Bell',
    phone: '+1-555-0162',
    email: 'mason.b@driveway.com',
    idType: 'other',
    idNumber: 'BL321654',
    resident: {
      id: 'RES040',
      name: 'Noah Cook'
    },
    expectedArrival: dayjs('2024-04-24T08:00:00').toDate(),
    expectedDeparture: dayjs('2024-04-26T17:00:00').toDate(),
    purpose: 'Driveway Paving',
    numberOfVisitors: 4,
    vehicleDetails: {
      type: 'Truck',
      number: 'DRIVE456',
      color: 'Gray'
    }
  },
  {
    id: 'VIS041',
    type: 'guest',
    status: 'expired',
    name: 'Sophia Murphy',
    phone: '+1-555-0163',
    email: 'sophia.m@email.com',
    idType: 'passport',
    idNumber: 'P65432198',
    resident: {
      id: 'RES041',
      name: 'Isabella Morgan'
    },
    expectedArrival: dayjs('2024-04-25T23:00:00').toDate(),
    expectedDeparture: dayjs('2024-04-27T21:00:00').toDate(),
    purpose: 'Family Visit',
    numberOfVisitors: 3
  },
  {
    id: 'VIS042',
    type: 'service',
    status: 'approved',
    name: 'Lucas Bailey',
    phone: '+1-555-0164',
    email: 'lucas.b@gutter.com',
    idType: 'drivers_license',
    idNumber: 'DL98765432',
    resident: {
      id: 'RES042',
      name: 'Mason Bell'
    },
    expectedArrival: dayjs('2024-04-26T10:00:00').toDate(),
    expectedDeparture: dayjs('2024-04-26T12:00:00').toDate(),
    purpose: 'Gutter Cleaning',
    numberOfVisitors: 2,
    vehicleDetails: {
      type: 'Van',
      number: 'GUTT789',
      color: 'White'
    }
  },
  {
    id: 'VIS043',
    type: 'delivery',
    status: 'checked_in',
    name: 'Evelyn Rivera',
    phone: '+1-555-0165',
    email: 'evelyn.r@grocery.com',
    idType: 'national_id',
    idNumber: 'EMP321654',
    resident: {
      id: 'RES043',
      name: 'Sophia Murphy'
    },
    expectedArrival: dayjs('2024-04-27T18:00:00').toDate(),
    expectedDeparture: dayjs('2024-04-27T18:10:00').toDate(),
    actualArrival: dayjs('2024-04-27T18:05:00').toDate(),
    purpose: 'Grocery Delivery',
    numberOfVisitors: 1,
    vehicleDetails: {
      type: 'Motorcycle',
      number: 'GROC123',
      color: 'Green'
    }
  },
  {
    id: 'VIS044',
    type: 'contractor',
    status: 'pending',
    name: 'Oliver Cooper',
    phone: '+1-555-0166',
    email: 'oliver.c@basement.com',
    idType: 'other',
    idNumber: 'BL654321',
    resident: {
      id: 'RES044',
      name: 'Lucas Bailey'
    },
    expectedArrival: dayjs('2024-04-28T09:00:00').toDate(),
    expectedDeparture: dayjs('2024-04-30T17:00:00').toDate(),
    purpose: 'Basement Finishing',
    numberOfVisitors: 3,
    vehicleDetails: {
      type: 'Truck',
      number: 'BASE456',
      color: 'Brown'
    }
  },
  {
    id: 'VIS045',
    type: 'guest',
    status: 'approved',
    name: 'Harper Richardson',
    phone: '+1-555-0167',
    email: 'harper.r@email.com',
    idType: 'passport',
    idNumber: 'P32165498',
    resident: {
      id: 'RES045',
      name: 'Evelyn Rivera'
    },
    expectedArrival: dayjs('2024-04-29T24:00:00').toDate(),
    expectedDeparture: dayjs('2024-05-01T22:00:00').toDate(),
    purpose: 'Weekend Stay',
    numberOfVisitors: 1
  },
  {
    id: 'VIS046',
    type: 'service',
    status: 'checked_in',
    name: 'Aiden Cox',
    phone: '+1-555-0168',
    email: 'aiden.c@solar.com',
    idType: 'drivers_license',
    idNumber: 'DL65432198',
    resident: {
      id: 'RES046',
      name: 'Oliver Cooper'
    },
    expectedArrival: dayjs('2024-04-30T12:00:00').toDate(),
    expectedDeparture: dayjs('2024-04-30T14:00:00').toDate(),
    actualArrival: dayjs('2024-04-30T12:15:00').toDate(),
    purpose: 'Solar Panel Installation',
    numberOfVisitors: 2,
    vehicleDetails: {
      type: 'Van',
      number: 'SOLAR789',
      color: 'Yellow'
    }
  },
  {
    id: 'VIS047',
    type: 'delivery',
    status: 'approved',
    name: 'Scarlett Ward',
    phone: '+1-555-0169',
    email: 'scarlett.w@furniture.com',
    idType: 'national_id',
    idNumber: 'EMP654321',
    resident: {
      id: 'RES047',
      name: 'Harper Richardson'
    },
    expectedArrival: dayjs('2024-05-01T19:00:00').toDate(),
    expectedDeparture: dayjs('2024-05-01T20:30:00').toDate(),
    purpose: 'Furniture Assembly',
    numberOfVisitors: 1,
    vehicleDetails: {
      type: 'Van',
      number: 'ASSEM123',
      color: 'White'
    }
  },
  {
    id: 'VIS048',
    type: 'contractor',
    status: 'approved',
    name: 'Sebastian Torres',
    phone: '+1-555-0170',
    email: 'sebastian.t@kitchen.com',
    idType: 'other',
    idNumber: 'BL321654',
    resident: {
      id: 'RES048',
      name: 'Aiden Cox'
    },
    expectedArrival: dayjs('2024-05-02T08:00:00').toDate(),
    expectedDeparture: dayjs('2024-05-04T17:00:00').toDate(),
    purpose: 'Kitchen Remodeling',
    numberOfVisitors: 3,
    vehicleDetails: {
      type: 'Truck',
      number: 'KITCH456',
      color: 'Gray'
    }
  },
  {
    id: 'VIS049',
    type: 'guest',
    status: 'pending',
    name: 'Madison Peterson',
    phone: '+1-555-0171',
    email: 'madison.p@email.com',
    idType: 'passport',
    idNumber: 'P65432198',
    resident: {
      id: 'RES049',
      name: 'Scarlett Ward'
    },
    expectedArrival: dayjs('2024-05-03T01:00:00').toDate(),
    expectedDeparture: dayjs('2024-05-05T23:00:00').toDate(),
    purpose: 'Business Trip',
    numberOfVisitors: 1
  },
  {
    id: 'VIS050',
    type: 'service',
    status: 'checked_in',
    name: 'Jackson Gray',
    phone: '+1-555-0172',
    email: 'jackson.g@lawn.com',
    idType: 'drivers_license',
    idNumber: 'DL98765432',
    resident: {
      id: 'RES050',
      name: 'Sebastian Torres'
    },
    expectedArrival: dayjs('2024-05-04T13:00:00').toDate(),
    expectedDeparture: dayjs('2024-05-04T15:00:00').toDate(),
    actualArrival: dayjs('2024-05-04T13:10:00').toDate(),
    purpose: 'Lawn Maintenance',
    numberOfVisitors: 1,
    vehicleDetails: {
      type: 'Truck',
      number: 'LAWN789',
      color: 'Green'
    }
  }
]; 